export default "__VITE_ASSET__BHJiKa1V__"